import ModelFactory from 'business/models/ModelFactory';
import { DewarClient, PuckClient } from 'business/models/Models';
import BaseService from 'business/services/BaseService';

export default class CrystalContainerService extends BaseService {
  async getAllDewars() {
    const _dewarClient: DewarClient = ModelFactory(DewarClient, false, true);
    return await _dewarClient.getAllDewars();
  }

  async getAllPucks() {
    const _puckClient: PuckClient = ModelFactory(PuckClient, false, true);
    return await _puckClient.getAllPucksWithOccupancyByTripId(-1);
  }

  async getAllPuckTypes() {
    const _puckClient: PuckClient = ModelFactory(PuckClient, false, true);
    return await _puckClient.getAllPuckTypes();
  }

  async saveDewars(saveData) {
    const _dewarClient: DewarClient = ModelFactory(DewarClient, false, true);
    return await _dewarClient.save(saveData);
  }

  async savePucks(saveData) {
    const _puckClient: PuckClient = ModelFactory(PuckClient, false, true);
    return await _puckClient.save(saveData);
  }
}
